import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ConnectorService } from '../connector.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isDisconnecting = false; // Éviter les déconnexions en boucle

  constructor(private connectorService: ConnectorService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      // Session glissante : le back renvoie un jeton neuf quand l'actuel a plus de 24 h
      tap(event => {
        if (event instanceof HttpResponse) {
          const token = event.headers.get('X-Refresh-Token');
          const expires = Number(event.headers.get('X-Token-Expires'));
          if (token && expires) this.connectorService.updateSession(token, expires);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        // Seule une 401 signifie "session invalide ou expirée" (SSOAuthGuard). Une 403 est
        // une action refusée (droits, règle métier) : la personne doit voir le message, pas
        // être déconnectée — c'est ce qui arrivait en modifiant son nom sur le mur.
        if (error.status === 401 && !this.isDisconnecting) {
          console.log('Erreur d\'authentification détectée (401), déconnexion automatique...');
          
          // Éviter les déconnexions en boucle
          this.isDisconnecting = true;
          
          // Déconnecter l'utilisateur automatiquement
          this.connectorService.disconnection();
          
          // Réinitialiser le flag après un délai
          setTimeout(() => {
            this.isDisconnecting = false;
          }, 1000);
        }
        
        return throwError(() => error);
      })
    );
  }
}
